import {Platform, Linking} from 'react-native';

export const openLocationInMaps = ({lat, long, pointLabel}: {lat: number; long: number; pointLabel: string}) => {
  // Check if running on web
  if (Platform.OS === 'web') {
    // Open Google Maps in browser for web
    const googleMapsUrl = `https://www.google.com/maps/search/${encodeURIComponent(pointLabel)}/@${lat},${long},15z`;
    window.open(googleMapsUrl, '_blank');
    return;
  }

  const scheme = Platform.select({ios: 'maps://0,0?q=', android: 'geo:0,0?q='});
  const latLng = `${lat},${long}`;
  const url = Platform.select({
    ios: `${scheme}${pointLabel}@${latLng}`,
    android: `${scheme}${latLng}(${pointLabel})`,
  });

  Linking.openURL(url || '');
};
